import Vue from 'vue';

import apiFactory from '@/api/default';
const API = apiFactory('cameratypes');

const state = {
  cameraTypesSearchResults: [],
  currentCameraType: {},
};

const getters = {
  cameraTypesSearchResults: (state) => state.cameraTypesSearchResults,
  currentCameraType: (state) => state.currentCameraType,
};

const mutations = {
  setCameraTypesSearchResults: (state, cameraTypesSearchResults) => {
    state.cameraTypesSearchResults = cameraTypesSearchResults;
  },
  updateCameraTypesSearchResults: (state, task) => {
    const index = state.cameraTypesSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.cameraTypesSearchResults, index, task);
  },
  removeFromCameraTypesSearchResults: (state, id)=>{
    state.cameraTypesSearchResults.data = state.cameraTypesSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.cameraTypesSearchResults.total--;
  },
  setCurrentCameraType: (state, currentCameraType) => {
    state.currentCameraType = currentCameraType;
  },
};


const actions = {
  async searchCameraTypes({commit}, data) {
    const response = await API.search(data.query);
    if (data.opts?.setResultsInStore) {
      commit('setCameraTypesSearchResults', response.data);
    }

    return response.data;
  },
  async loadCameraType({commit}, data) {
    const response = await API.load(data.id, data.query);
    commit('setCurrentCameraType', response.data);
    return response.data;
  },
  async createCameraType({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateCameraType({commit}, payload) {
    const response = await API.update(payload.id, payload.props);
    commit('updateCameraTypesSearchResults', response.data);
    return response.data;
  },
  async deleteCameraType({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromCameraTypesSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
